<script>
import Layout from '@layouts/main'
import LayoutMemberPrepaid from '@layouts/LayoutMemberPrepaid'
import { merchantComputed } from '@state/helpers'
import formatDate, { dateDiffInMinutes } from '@utils/format-date'

export default {
  page() {
    return {
      title: this.$t('global.MEMBER_PREPAID'/* 預付方案 */),
    }
  },
  components: { Layout, LayoutMemberPrepaid },
  filters: {
    formatDate,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      defaultImage: require('@assets/images/activity_default.png'),
      showOtherStatus: false,
    }
  },
  computed: {
    ...merchantComputed,
    history() {
      return this.order.history.filter(item => {
        return item.status === 1 || this.showOtherStatus
      })
    },
    orderTimeInterval() {
      return dateDiffInMinutes(this.order.startDate, this.order.endDate)
    },
    paramsSizeTotal() {
      let size = 0;

      this.order.params.forEach(param => {
        size += param.size * param.qty
      });

      return size
    },
    gender() {
      const gender = {
        male: this.$t('global.MALE' /* 先生 */),
        female: this.$t('global.FEMALE' /* 小姐 */),
      };
      return gender[this.order.gender]
    },
    paymentMethod() {
      const paymentMethod = {
        prepaid: this.$t('global.PAYMENT_METHOD_PREPAID' /* 預付抵用 */),
        cash: this.$t('global.PAYMENT_METHOD_CASH' /* 現金付款 */),
        creditCard: this.$t('global.PAYMENT_METHOD_CREDITCARD' /* 信用卡付款 */),
        free: this.$t('global.PAYMENT_METHOD_FREE' /* 免費 */),
      };
      return paymentMethod[this.order.paymentMethod]
    },
    isNullOrder() {
      return typeof this.order === 'object' && Object.keys(this.order).length === 0
    }
  },
  methods: {
    orderStatusText(orderStatus) {
      const status = [
        this.$t('global.CANCELED' /* 已取消 */),
        this.$t('global.PAID' /* 已付款 */),
        this.$t('global.UNPAID' /* 未付款 */),
      ];
      return status[orderStatus]
    },
    historyStatus(historyStatus) {
      const history = [
        this.$t('global.CANCELED' /* 已取消 */),
        this.$t('global.DEDUCTED' /* 已抵用 */),
        this.$t('global.CONFIRMED' /* 待確認 */),
      ];

      return history[historyStatus]
    },
    historyStatusClass(historyStatus) {
      const historyClassMap = {
        0: 'is-orange',
        1: 'is-primary',
        2: 'is-danger',
      };
      return historyClassMap[historyStatus]
    },
    orderStatusClass(orderStatus) {
      const statusClassMap = {
        0: 'is-orange',
        1: 'is-primary',
        2: 'is-danger',
      };
      return statusClassMap[orderStatus]
    },
    handleToProductOrder(order) {
      this.$router.push({
        name: 'member-order-item',
        params: {
          orderKey: order.id
        },
        query: {
          language: this.$route.query.language,
        },
      })
    },
  },
}
</script>

<template>
  <Layout>
    <LayoutMemberPrepaid :order="order">
      <template v-if="!isNullOrder">
        <div :class="$style.wrapper">
          <div :class="$style.inner" class="is-mobile-column-reverse">
            <div class="columns is-multiline is-mobile is-mobile-column-reverse">
              <div class="column is-full-mobile is-half-tablet">
                <div class="media is-align-items-stretch">
                  <figure class="media-left">
                    <picture>
                      <BaseImage
                        :src="order.prepaid.introimage"
                        :error-src="defaultImage"
                        :class="$style.image"
                        class-name="is-cover"
                      />
                    </picture>
                  </figure>
                  <div class="media-content">
                    <div :class="$style.titleBox" class="level">
                      <div :class="$style.title" class="level-left">
                        <b-tag :type="orderStatusClass(order.status)" rounded style="margin-right: 0.5rem">
                          {{orderStatusText(order.status) }}
                        </b-tag> {{ order.prepaid.title }}
                      </div>
                    </div>
                    <div class="has-text-grey-light is-text-content">
                      {{ order.merchant.name }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="column is-full-mobile is-half-tablet">
                <div>
                  <div class="level" style="margin-bottom: 0">
                    <div class="level-left"></div>
                    <div class="level-right">
                      <div class="has-text-grey-light" style="margin-bottom: 1rem">{{ $t('global.ORDER_NO'/*訂單編號*/) }} #{{order.orderNo}}</div>
                    </div>
                  </div>
                  <div class="level">
                    <div class="level-left"></div>
                    <div class="level-right">
                      <div v-if="order.status !== 2"
                           :class="[$style.styleBlockItem, { [$style.isDisabled]: order.status === 0 }]">
                        <div class="level is-mobile">
                          <div class="level-left">
                            <span class="has-text-grey-light" style="margin-right: 0.5rem">{{ $t('global.REMAINDER_DEDUCT'/*剩餘抵用次數*/) }}</span>
                          </div>
                          <div class="level-right">
                           <span :class="order.status === 0 ? 'has-text-grey-light' : 'has-text-primary'"
                                 class="is-size-4">
                              {{order.times - order.used}}/{{order.times}}
                           </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div :class="$style.inner">
            <div :class="$style.columnAlign" style="margin-bottom: 1rem;width: 100%;">
              <div class="level">
                <div class="level-left">{{ $t('global.PREPAID_HISTORY'/*方案使用歷程*/) }}</div>
                <div class="level-right">
                  <b-switch
                    v-model="showOtherStatus"
                    type="is-primary"
                  >
                    {{ $t('global.DISPLY_ALL_ORDER'/*顯示已取消和待確認訂單*/) }}
                  </b-switch>
                </div>
              </div>
            </div>
            <div :class="$style.columnAlign">
              <div v-if="order.history.length > 0" :class="$style.historyList">
                <div v-for="(historyItem, index) in history"
                     :key="index"
                     :class="$style.historyItem"
                     @click="handleToProductOrder(historyItem)">
                  <div :class="$style.column">
                    <div>
                      <div :class="$style.title" class="level" style="margin-bottom: 0.5rem">
                        <div class="level-left">
                          <b-tag :type="historyStatusClass(historyItem.status)"
                                 rounded
                                 style="margin-right: 0.5rem">
                            <span>{{historyStatus(historyItem.status) }}</span>
                          </b-tag>
                          <span :class="$style.historyItem__title">{{historyItem.productName}}</span>
                        </div>
                      </div>
                      <p :class="$style.content" class="has-text-grey-light">
                        {{ $t(`product.activity.TITLE_TIME`/*活動時間*/) }}：
                        {{historyItem.startDate | formatDate('dateTime')}}
                      </p>
                    </div>
                  </div>
                  <div :class="$style.column" style="width: 160px">
                    <div>
                    <span class="">
                      <span>{{ $t('global.PREPAID_DEDUCT'/*抵用次數*/) }}：</span>
                      <span v-if="historyItem.status === 1">{{historyItem.deductTimes}}</span>
                      <span v-else>0</span>
                    </span>
                      <br>
                    </div>
                  </div>
                  <div :class="$style.column" style="width: 130px">
                    <div>
                      <span class="">{{ $t('global.ORDER_CREATED'/*訂單成立時間*/) }}</span>
                      <br><span class="has-text-grey-light">{{historyItem.created | formatDate}}</span>
                    </div>
                  </div>
                  <div :class="$style.column" style="width: 130px">
                    <b-button
                      type="is-primary"
                      outlined
                      rounded
                      class="is-mobile-fullwidth"
                      @click="handleToOrder"
                    >{{ $t('global.HISTORY_ORDER_VIEW_DETAIL'/*查看訂單*/) }}</b-button>
                  </div>
                </div>
              </div>
              <div v-else class="has-text-grey-light">{{ $t('global.HISTORY_ORDER_NULL'/*尚未使用*/) }}</div>
            </div>
          </div>
        </div>
      </template>

    </LayoutMemberPrepaid>
  </Layout>
</template>
<style lang="scss" module>
  .wrapper {
    &:not(:last-child) {
      .inner {
        border-bottom: 1px solid $color-border-base;
      }
    }
    .inner:not(:last-child) {
      border-bottom: 1px solid $color-border-base;
    }

    .inner {
      padding: 1rem 0 0.9rem;
      margin: 0 1.5rem;
    }
  }

  .historyList {
    padding-left: 2rem;
    position: relative;
    &:after {
      position: absolute;
      top: 28px;
      bottom: 50px;
      width: 1px;
      background: $color-border-base;
      left: 0;
      content: '';
    }
    .historyItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1rem 0;
      position: relative;
      @include mobile {
        flex-direction: column;
        align-items: end;
      }
      &:after {
        content: '';
        width: 10px;
        height: 10px;
        background: lighten($color-primary, 15%);
        box-shadow: 0 2px 13px 0 rgba(83, 194, 204, 0.5);
        position: absolute;
        border-radius: 100%;
        left: -36px;
        top: 25px;
        z-index: 1;
      }
      &:hover {
        cursor: pointer;
        .historyItem__title {
          color: $color-primary;
        }
      }
      &:not(:last-child) {
        border-bottom: 1px solid $color-border-base;
      }
      > .column {
        &:first-child {
          flex: 3;
          display: flex;
          align-items: center;
          @include mobile {
            flex: 2;
            flex-direction: column;
            align-items: flex-start;
            padding-right: 0.5rem;
          }
          > .column {
            flex: 1;
          }
        }
      }
    }
  }

  .titleBox {
    align-items: flex-start;
    margin-bottom: 1rem;
    .title {
      max-width: 388px;
      align-items: flex-start;
    }
  }

  .styleBlockItem {
    border: 1px solid $color-primary;
    border-radius: 5px;
    padding: 0.75rem 1rem;
    text-align: left;
    &.isDisabled {
      border: 1px solid #b5b5b5;
    }
  }

  .image {
    height: 100px;
    width: 150px;
    overflow: hidden;
    background: $grey-lighter no-repeat;
    border-radius: $size-image-border-radius;
    position: relative;
    background-size: cover;
    @include mobile {
      width: 100px;
      height: 70px;
    }
  }
  .hr {
    border-bottom: 1px dashed $color-border-base;
    margin: 1rem 0;
    background: transparent;
  }
</style>
